<template>
	<div class="home">
		<h1 class="page-title" v-if="!isMob">Главная</h1>
		<div class="games">
			<component class="games__item" v-for="item in items" :is="item.disabled ? 'div':'router-link' " :to="item.disabled ? null : item.link" :class="item.disabled ? 'disabled' : ''">
				<div class="games__item-banner" v-if="item.image">
					<img class="games__item-banner-img" :src="isTablet ? item.image.srcMob : item.image.src" :alt="item.image.alt">
				</div>
				<div class="games__item-content">
					<svg class="games__item-icon">
						<use :href="`#svg-icon-${item.icon}`"></use>
					</svg>
					<div class="games__item-text">{{item.text}}</div>
				</div>
			</component>
		</div>
	</div>
</template>

<script>

import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";

export default {

	mixins: [
		breakpointsMixin
	],

	data() {
		return {
			items: [
				{
					text: 'Dice',
					link: '/dice',
					image: {
						src: '/assets/boomx/images/dice.jpg',
						srcMob: '/assets/boomx/images/dice-mob.jpg',
						alt: 'dice'
					},
					icon: 'dice',
					disabled: false
				},
				{
					text: 'Mines',
					link: '/mines',
					image: {
						src: '/assets/boomx/images/mines.jpg',
						srcMob: '/assets/boomx/images/mines-mob.jpg',
						alt: 'mines'
					},
					icon: 'mines',
					disabled: false
				},
				{
					text: 'Slots',
					link: '/slots',
					image: {
						src: '/assets/boomx/images/slots.jpg',
						srcMob: '/assets/boomx/images/slots-mob.jpg',
						alt: 'slots'
					},
					icon: 'slots',
					disabled: false
				},
				{
					text: 'Live',
					link: '/live',
					image: {
						src: '/assets/boomx/images/live.jpg',
						srcMob: '/assets/boomx/images/live-mob.jpg',
						alt: 'live'
					},
					icon: 'live',
					disabled: false
				},
				{
					text: 'Coin',
					link: '/coinflip',
					image: {
						src: '/assets/boomx/images/coin.jpg',
						srcMob: '/assets/boomx/images/coin-mob.jpg',
						alt: 'coin'
					},
					icon: 'coin',
					disabled: false
				},
				{
					text: 'Wheel',
					link: '/wheel',
					image: {
						src: '/assets/boomx/images/wheel.jpg',
						srcMob: '/assets/boomx/images/wheel-mob.jpg',
						alt: 'wheel'
					},
					icon: 'wheel',
					disabled: true
				}
			]
		}
	}
}

</script>